import { render, staticRenderFns } from "./SelectionDropdown.vue?vue&type=template&id=21d3740a&"
import script from "./SelectionDropdown.vue?vue&type=script&lang=ts&"
export * from "./SelectionDropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports